module.exports = __webpack_public_path__ + "img/Okko.a06872cd.png";